var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"um_imgzoom_mask",attrs:{"id":_vm.maskId}},[_c('i',{staticClass:"um_imgzoom_close el-icon-circle-close",attrs:{"id":_vm.imgCloseId}}),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',[_c('i',{staticClass:"el-icon-loading"}),_vm._v("请稍后...")])
}]

export { render, staticRenderFns }